import { render, staticRenderFns } from "./errorMsg.vue?vue&type=template&id=22c9d5b8&scoped=true&"
import script from "./errorMsg.vue?vue&type=script&lang=js&"
export * from "./errorMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9d5b8",
  null
  
)

export default component.exports